/**
 * Hosts that are legitimately served over plain HTTP — local dev and anything
 * hitting the SSR container directly. Everything else is https-only in every
 * deployed environment.
 */
const PLAIN_HTTP_HOSTNAMES = new Set(["localhost", "127.0.0.1", "[::1]", "::1"]);

/**
 * Forces an absolute URL onto https unless it points at a loopback host.
 *
 * Used for URLs that get published rather than followed — JSON-LD `@id`/`url`
 * fields, which search engines treat as identifiers. Those must match the
 * canonical https origin even if the request they were derived from arrived over
 * plain HTTP, so this stays correct independently of whether the proxy sent
 * `X-Forwarded-Proto` (see {@link resolveForwardedProtoUrl}).
 *
 * Returns the input untouched when it is not a parseable absolute URL.
 */
export const ensureHttpsUrl = (url: string): string => {
  let parsed: URL;

  try {
    parsed = new URL(url);
  } catch {
    return url;
  }

  if (parsed.protocol !== "http:" || PLAIN_HTTP_HOSTNAMES.has(parsed.hostname)) {
    return url;
  }

  parsed.protocol = "https:";

  return parsed.toString();
};
